import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "components/ui/button";
import { Form, FormField, FormItem, FormMessage } from "components/ui/form";
import { Input } from "components/ui/input";
import { toast } from "components/ui/use-toast";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useCreateAccountingAccountMutation } from "../../../../services/account-accouting";
import { FormSchema } from "./validate-form";
import { useDialogModal } from "../../../../hook/handle-modal/hooks/actions";
import { MESSAGES } from "../utils/messages";

export function Create() {
  const [createAccountingAccount, { isLoading }] =
    useCreateAccountingAccountMutation();
  const { handleModal } = useDialogModal();

  const form = useForm<z.infer<typeof FormSchema>>({
    resolver: zodResolver(FormSchema),
  });

  async function onSubmit(data: z.infer<typeof FormSchema>) {
    try {
      await createAccountingAccount({
        name: data?.name || "",
      }).unwrap();
      toast(MESSAGES?.CREATE?.SUCCESS);
      handleModal({
        isOpen: false,
      });
      form.reset();
    } catch (e) {
      toast(MESSAGES.CREATE.ERROR);
    }
  }
  return (
    <>
      <div className="grid gap-4">
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="space-y-4">
              <FormField
                control={form.control}
                name="name"
                render={({ field }) => (
                  <FormItem>
                    <Input
                      {...field}
                      hasError={!!form.formState.errors.name}
                      name="name"
                      placeholder="Conta Contábil."
                    />
                    <FormMessage />
                  </FormItem>
                )}
              />

              <div className="flex w-full justify-end gap-4">
                <button
                  className="self-end w-max px-4 py-2 border border-black/20 flex items-center gap-2 rounded-md
                     text-black bg-white
                     transition-all duration-300 ease-in-out
                     hover:bg-[#2B0C1A] hover:text-white hover:border-transparent
                     "
                  onClick={() =>
                    handleModal({
                      isOpen: false,
                    })
                  }
                >
                  Voltar
                </button>
                <Button type="submit" variant="default" isLoading={isLoading}
                  className="rounded-md">
                  Salvar
                </Button>
              </div>
            </div>
          </form>
        </Form>
      </div>
    </>
  );
}
